"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.certificationClick = void 0;
var consts_1 = require("../consts");
var certificationClick = function (event) {
    var _a, _b, _c, _d, _e;
    return {
        event: "certifications:click",
        eventInfo: "certifications:click",
        action: (_a = event === null || event === void 0 ? void 0 : event.eventData) === null || _a === void 0 ? void 0 : _a.action,
        certification: {
            applicationID: ((_b = event === null || event === void 0 ? void 0 : event.eventData) === null || _b === void 0 ? void 0 : _b.certification.applicationID) || consts_1.NOT_AVAILABLE,
            certName: ((_c = event === null || event === void 0 ? void 0 : event.eventData) === null || _c === void 0 ? void 0 : _c.certification.certName) || consts_1.NOT_AVAILABLE,
            status: ((_e = (_d = event === null || event === void 0 ? void 0 : event.eventData) === null || _d === void 0 ? void 0 : _d.certification) === null || _e === void 0 ? void 0 : _e.status) || consts_1.NOT_AVAILABLE,
        },
    };
};
exports.certificationClick = certificationClick;
